import React from 'react';

const DefaultRow = ({filter, conditionsList, updateCondition, updateValue}) => {
  return (
    <span>
      <select value={filter.condition} onChange={e=> updateCondition(e.target.value)}>
        { conditionsList.map((o, i) => <option key={i} value={o}>{o}</option>) }
      </select>&nbsp;
      { !['is empty', 'is not empty'].includes(filter.condition) &&
        <input
          className='filter-form-input' placeholder='Select an option' type='text' value= {filter.value}
          onChange={(e) => {updateValue(e.target.value)}}
        />
      }
    </span>
  )
}

export default DefaultRow
